export default function guest({ next, store }) {

    if (store.state.main.root || store.state.main.newUser) {
        return next({
            name: 'main'
        })
    }

    return next()


}